import { API_PATHS } from '../../../lib/apiRoutes';
import { apiRequest } from '../../../lib/api';
import { buildStickyIdempotencyKey } from '../../../lib/idempotency';
import type { RedeemRewardsRequest, RedeemRewardsResponse } from '../types/rewards.types';

/** Feature API contract source of truth: docs/api/endpoints.md */
export const REWARDS_API_CONTRACT = {
  redeem: API_PATHS.loyaltyPoints.redeem,
  requiredPayloadKeys: {
    redeem: ['points', 'reason', 'referenceId', 'idempotencyRef']
  }
} as const;

export const rewardsApi = {
  redeemPoints: (payload: RedeemRewardsRequest) => {
    const points = Math.abs(Math.trunc(payload.points));
    // Sticky intent — retries after timeout must not double-convert points→wallet.
    const referenceId =
      payload.referenceId?.trim() ||
      buildStickyIdempotencyKey('loyalty-redeem-ref', [payload.userId, points, payload.reason]);
    const idempotencyRef =
      payload.idempotencyRef?.trim() ||
      buildStickyIdempotencyKey('loyalty-redeem', [payload.userId, points, payload.reason, referenceId]);
    return apiRequest<RedeemRewardsResponse>(REWARDS_API_CONTRACT.redeem, {
      method: 'POST',
      body: JSON.stringify({
        points,
        reason: payload.reason,
        referenceId,
        idempotencyRef
      }),
      idempotencyKey: idempotencyRef,
      requireIdempotencyKey: true
    });
  }
};
